export enum Providers {
  COOKIEBOT = "cookiebot",
  ONETRUST = "onetrust",
}
